function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "6f635be9ed"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 82.5 37.5 L 292.5 37.5 L 292.5 337.5 L 82.5 337.5 Z M 82.5 37.5 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#6f635be9ed)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 187.5 37.5 C 129.523438 37.5 82.5 84.523438 82.5 142.5 C 82.5 221.25 187.5 337.5 187.5 337.5 C 187.5 337.5 292.5 221.25 292.5 142.5 C 292.5 84.523438 245.476562 37.5 187.5 37.5 Z M 187.5 180 C 166.800781 180 150 163.199219 150 142.5 C 150 121.800781 166.800781 105 187.5 105 C 208.199219 105 225 121.800781 225 142.5 C 225 163.199219 208.199219 180 187.5 180 Z M 187.5 180 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
function SvgUbiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbiIcon);
export default __webpack_public_path__ + "static/media/ubi-icon.8ead745fe895d096e20dd7744d304f2b.svg";
export { ForwardRef as ReactComponent };